import React from 'react';

import { IntakePrepResponsibility } from 'src/generated/gql/graphql';
import { labelForEventType } from 'src/shared/util/events';
import { BoulderColors } from 'src/util/brand';

type EventTypeLabelProps = {
  type?: string | null;
  subType: string;
  prepResponsibility?: IntakePrepResponsibility;
};

export const EventTypeLabel = ({ type, subType, prepResponsibility }: EventTypeLabelProps) => {
  const isPreppedIntake =
    subType.includes('intake') && prepResponsibility === IntakePrepResponsibility.CareAdvocate;
  const isUnpreppedIntake =
    subType.includes('intake') && prepResponsibility === IntakePrepResponsibility.Clinician;

  return (
    <span>
      {labelForEventType(type ?? null, subType).toUpperCase()}
      {isPreppedIntake && (
        <>
          {' | '}
          <span style={{ color: BoulderColors.Green }}>●</span> Prepped
        </>
      )}
      {isUnpreppedIntake && (
        <>
          {' | '}
          <span style={{ color: BoulderColors.Gold }}>●</span> Not prepped
        </>
      )}
    </span>
  );
};
